import { IBudget } from 'modules/checkout/domain/entities';
import { TPaymentMethodType } from 'shared/domain/entities';

/**
 * As formas que devem ser oferecidas a quem já está pagando com `payingMethod` — o fomento a
 * formas de pagamento garantidas.
 *
 * Quem decide é o Vectis, por país e por unidade, e a lista já vem filtrada pelas formas que a
 * unidade oferece. Antes a regra morava na tela e valia só para o idioma português: o fomento
 * não existia fora do Brasil e não havia como desligá-lo.
 *
 * A segunda filtragem, contra as formas do próprio orçamento, não é desconfiança do Vectis: a
 * unidade pode oferecer uma forma que este orçamento não tem — por item sem desconto, por
 * inadimplência do cliente ou por condição de pagamento ausente. Oferecer o que não está na
 * tela levaria o cliente a um card que não dá para escolher.
 */
export default function getPaymentMethodOffers(
  budget: IBudget,
  payingMethod: TPaymentMethodType | null,
): TPaymentMethodType[] {
  if (!payingMethod) return [];

  const offers = budget.paymentMethodOffers.offers[payingMethod] ?? [];

  return offers.filter(offer =>
    budget.paymentMethods.some(paymentMethod => paymentMethod.key === offer),
  );
}
